import React from "react";

import { ServiceButton, ServiceIcon, ServiceIconService } from "@meterup/metric";

import { useAppOptions, useOAuthURLs } from "../appOptions";

export default function App() {
  const appOptions = useAppOptions();
  const oauthURLs = useOAuthURLs();

  const OktaSSOURL = appOptions?.OktaSSOURL;
  const { GoogleSSOURL, MicrosoftSSOURL } = oauthURLs;

  return (
    <>
      <a href={GoogleSSOURL}>
        <ServiceButton
          label="Sign in with Google"
          icon={<ServiceIcon service={ServiceIconService.Google} />}
          className="m-font-medium"
          size="extra-large"
        />
      </a>
      <a href={MicrosoftSSOURL}>
        <ServiceButton
          label="Sign in with Microsoft"
          icon={<ServiceIcon service={ServiceIconService.Microsoft} />}
          className="m-font-medium"
          size="extra-large"
        />
      </a>
      {OktaSSOURL && (
        <a href={OktaSSOURL}>
          <ServiceButton
            label="Sign in with Okta"
            icon={<ServiceIcon service={ServiceIconService.Okta} />}
            className="m-font-medium"
            size="extra-large"
          />
        </a>
      )}
    </>
  );
}
